module.exports = __webpack_public_path__ + "img/3.891bf9e7.jpg";